import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { kbBrakeAppService } from 'src/app/services/feature/kb-brakeApplication/KbBrakeApplication.service';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';
import { BrakeAppAdminDialogPopupComponent } from '../brake-app-admin-form/brake-app-admin-dialog-popup/brake-app-admin-dialog-popup.component';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-brake-app-edit-form',
  templateUrl: './brake-app-edit-form.component.html',
  styleUrls: ['../kbBrakeApllicationForms-module/kbBrakeApllicationForms-module.component.scss',
    '../brake-app-admin-form/brake-app-admin-form.component.scss',
    './brake-app-edit-form.component.scss'],
  standalone: false
})
export class BrakeAppEditFormComponent {
  adminNameArray: any;
  approvalTypeArray: any;
  sub = new Subscription();
  isMobile: boolean;
  checkFormClicked: boolean = false;
  apiFileLength: number = 0;
  today: Date = new Date();
  fileLength$: Observable<any> = this.fileService.getCurrentFileCount();
  IsNonEditable: boolean = false;
  saveForLater: boolean = false;
  BrakeFormGetApiData: any;
  canLoadPage: boolean = false;
  customerIdFromCommonEnd: any;
  brakeAppCode: string = '';
  //Admin Comments
  adminComments: any
  //checkboxesLoaders
  levelofExperience: any;
  projectTargetContent: any;
  EnduranceBrakeSystem: any;
  oemPTReqContent: any;
  vehicleOECContent: any;
  addAuxleAttrContent: any;

  //dropdownLoaders
  oEM: any;
  three3DCAD: any;
  vehicleModel: any;
  vehicleType: any;
  vocation: any;
  fieldTestPlanned: any
  pneumatic: any;
  brakeType: any;
  axleManufacturer: any;
  partPerforming: any;
  axleDesign: any;
  tOCAxleFlange: any;
  axleType: any;
  intendedOrDesigned: any;
  tireType: any;
  auxiliaryAxleType: any;
  bsConfigFormat: string = '';




  service = inject(kbBrakeAppService);
  //pagestatus
  savedSuccessFully: boolean = false;
  isFormContainsError: boolean = false;
  isFormFilledSuccessfully: boolean = false;
  submittedSuccessFully: boolean = false;
  //want to throw errors when atleast one checkbox is not selected
  levelofExpError: boolean = false;
  projecttargetError: boolean = false;
  endurancebrakeSyserror: boolean = false;
  isButtonDisable: boolean = true;
  platformId = inject(PLATFORM_ID);
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(private breakpointObserver: BreakpointObserver,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private activatedroute: ActivatedRoute,
    private custIdService: CustomerIdService,
    private fileService: KbFileService,
    private matDialog: MatDialog,
    private scroller: ViewportScroller
  ) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  brakeApplicationForm = new FormGroup({
    //------------------checkboxes---------------
    levelOfExp: new FormArray([]),
    projectTarget: new FormArray([]),
    enduranceBreakSys: new FormArray([]),
    oemPTReq: new FormArray([]),
    vehicleOEC: new FormArray([]),
    //--------------------radibuttons-------------------
    samplesRequired: new FormControl('false'),
    targetDateAvailable: new FormControl('false'),
    vehicleOperationalOutside: new FormControl('false'),
    endUserPTReq: new FormControl('false'),
    steerAxleDriven: new FormControl('false'),
    brakeEquippeds: new FormControl('false'),

    //---------------------dropdowns----------------------------
    oem: new FormControl(null, [Validators.required]),
    ftPlanned: new FormControl(null, [Validators.required]),
    cadModelAvailability: new FormControl(null, [Validators.required]),
    vehicleModel: new FormControl(null, [Validators.required]),
    vehicleType: new FormControl(null, [Validators.required]),
    vocation: new FormControl(null, [Validators.required]),
    brakeType: new FormControl(null, [Validators.required]),
    pneumaticSystem: new FormControl(null, { validators: Validators.required }),
    steerAxleManu: new FormControl(null, [Validators.required]),
    steerAxleBAIP: new FormControl(null, [Validators.required]),
    steerAxleStatus: new FormControl(null, [Validators.required]),
    steerAxleType: new FormControl(null, [Validators.required]),
    steerAxleTOC: new FormControl(null, [Validators.required]),
    steerAxleParking: new FormControl(null, [Validators.required]),
    steerAxleTireType: new FormControl(null, [Validators.required]),
    driveAxleManu: new FormControl(null, [Validators.required]),
    driveAxleBAIP: new FormControl(null, [Validators.required]),
    driveAxleStatus: new FormControl(null, [Validators.required]),
    driveAxleType: new FormControl(null, [Validators.required]),
    driveAxleParking: new FormControl(null, { validators: Validators.required }),
    driveAxleTOC: new FormControl(null, { validators: Validators.required }),
    driveAxleTireType: new FormControl(null, { validators: Validators.required }),

    //--------------dynamicfields-----------------

    driveAxleManuBox: new FormControl(null, { validators: Validators.required }),
    driveAxleTOCBox: new FormControl(null, { validators: Validators.required }),
    steerAxleManuBox: new FormControl(null, { validators: Validators.required }),
    steerAxleTOCBox: new FormControl(null, { validators: Validators.required }),


    //---------input fields---------------
    soldToNumber: new FormControl(null, [Validators.required]),
    date: new FormControl(null, [Validators.required]),
    applicationNum: new FormControl(null),
    firstName: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required]),
    phone: new FormControl(null),
    controlNumber: new FormControl(null),
    productionStartDate: new FormControl(null, [Validators.required]),
    firstYearVol: new FormControl(null, [Validators.required]),
    secondYearVol: new FormControl(null, [Validators.required]),
    thirdYearVol: new FormControl(null, [Validators.required]),
    endUser: new FormControl(null),
    ftVehicleCount: new FormControl(null),
    ftDetails: new FormControl(null, [Validators.required]),
    paintingCondition: new FormControl(null),
    chassisNumber: new FormControl(null, [Validators.required]),
    chassisModification: new FormControl(null, [Validators.required]),
    vehicleLifetime: new FormControl(null, [Validators.required]),
    annualUsage: new FormControl(null, [Validators.required]),
    onHighwayUsage: new FormControl(null, [Validators.required]),
    maximumOptimumGrade: new FormControl(null, [Validators.required]),
    serviceBrakeDutyCycle: new FormControl(null, [Validators.required]),
    parkingDutyCycle: new FormControl(null, [Validators.required]),
    nvhRequirements: new FormControl(null),
    axleConfig: new FormControl(null, [Validators.required]),
    absSensorCount: new FormControl(null),
    absModulatorCount: new FormControl(null, [Validators.required]),
    gvwr: new FormControl(null, [Validators.required]),
    wheelBaseRange: new FormControl(null, [Validators.required]),
    cgHeightLaden: new FormControl(null, [Validators.required]),
    cgHeightUnladen: new FormControl(null, [Validators.required]),
    steerAxleBrakeDiscInfo: new FormControl(null, [Validators.required]),
    steerAxleBrakeActInfo: new FormControl(null, [Validators.required]),
    steerAxleValveCP: new FormControl(null, [Validators.required]),
    steerAxleGAWR: new FormControl(null, [Validators.required]),
    steerAxleWeightLimit: new FormControl(null),
    steerAxleWheelRimSize: new FormControl(null, [Validators.required]),
    steerAxleSLR: new FormControl(null, [Validators.required]),
    steerAxleCustPropBrake: new FormControl(null),
    driveAxleBrakeDiscInfo: new FormControl(null, [Validators.required]),
    driveAxleBrakeActInfo: new FormControl(null, [Validators.required]),
    driveAxleValveCP: new FormControl(null, [Validators.required]),
    driveAxleWeightLimit: new FormControl(null),
    driveAxleGAWR: new FormControl(null, [Validators.required]),
    driveAxleWheelRimSize: new FormControl(null, [Validators.required]),
    driveAxleSLR: new FormControl(null, [Validators.required]),
    driveAxleCustPropBrake: new FormControl(null),
    customerComment: new FormControl(null),
    auxAxleList: this.fb.array([]),
    approvalType: new FormControl(null),
  })
  dynamicFormArray() {
    return new FormGroup({
      auxAxleManu: new FormControl(null, [Validators.required]),
      auxAxleBAIP: new FormControl(null, [Validators.required]),
      auxAxleStatus: new FormControl(null, [Validators.required]),
      auxAxleTOC: new FormControl(null, [Validators.required]),
      auxAxleBrakeDiscInfo: new FormControl(null, [Validators.required]),
      auxAxleBrakeActInfo: new FormControl(null, [Validators.required]),
      auxAxleValveCP: new FormControl(null, [Validators.required]),
      auxAxleType: new FormControl(null, [Validators.required]),
      auxAxleWeightLimit: new FormControl(null),
      auxAxleGAWR: new FormControl(null, [Validators.required]),
      auxAxleWheelRimSize: new FormControl(null, [Validators.required]),
      auxAxleTireType: new FormControl(null, [Validators.required]),
      auxAxleSLR: new FormControl(null, [Validators.required]),
      auxAxleCustPropBrake: new FormControl(null),
      auxAxleAttributes: new FormArray([]),
      auxAxleManuBox: new FormControl(null),
      auxAxleTOCBox: new FormControl(null),
    })
  }
  get bAF() {
    return this.brakeApplicationForm.controls;
  }
  get auxAxleList(): FormArray {
    return this.brakeApplicationForm.get('auxAxleList') as FormArray;
  }
  getAxleListControl(index: number, controlName: string): any {
    return this.brakeApplicationForm.get('auxAxleList').get(index.toString()).get(controlName);
  }
  checkFieldIsThere(index: number, controlName: string): boolean {
    const auxAxleList = this.brakeApplicationForm.get('auxAxleList') as FormArray;
    const formGroupAtIndex = auxAxleList.at(index) as FormGroup;
    return formGroupAtIndex.contains(controlName);
  }

  engineeringForm = new FormGroup({
    adminName: new FormControl(null),
    applicationNum: new FormControl(null),
    applicationDate: new FormControl(null),
    partNumber: new FormControl(null),
    applicationFront: new FormControl(null),
    applicationForward: new FormControl(null),
    additionComments: new FormControl(null),
    applicationMid: new FormControl(null),
    applicationRear: new FormControl(null),
    applicationPusher: new FormControl(null),
    applicationTag: new FormControl(null),
    applicationAxle: new FormControl(null),
    applicationMail: new FormControl(null),
    approavalStatus: new FormControl(null),
    approvalType: new FormControl(null)
  })
  get eAdminF() {
    return this.engineeringForm.controls;
  }
  ngOnInit() {
    this.sub.add(this.activatedroute.queryParamMap.subscribe((params) => {
      const code = params.get('code');
      this.brakeAppCode = code;
      this.sub.add(this.service.adminBrakeAppEditpage(code).subscribe((res: any) => {
        this.loopDropDownListArray(res?.dropdownList);
        this.BrakeFormGetApiData = res;
        this.bsConfigFormat = this.BrakeFormGetApiData?.dateFormat.toUpperCase()
        this.approvalTypeArray = res?.approvalStatus?.entry;
        this.adminNameArray = res?.adminName?.entry;
        this.eAdminF.applicationNum.setValue(code);
        this.customerIdFromCommonEnd = this.custIdService.customerIdData.b2bUnitsWSList;
        res?.formData?.auxAxleList.map((data) => {
          this.addDynamic();
        });
        this.apiFileLength = res?.fileAttachmentList?.length;
        this.updateRadioButtonFormControls(res?.formData);
        this.formfieldAutoupdater(res);
        this.addDynamicfields();
        this.formfieldAutoupdater(res);
        this.populateEngineeringForm(res?.adminCommentForm);
        if (res?.adminCommentForm?.approvalType.toUpperCase() == 'AWAITING') {
          this.IsNonEditable = false;
          this.isButtonDisable = true;
        } else {
          this.IsNonEditable = true;
          this.isButtonDisable = false;
        }
        this.canLoadPage = true;
        if (this.brakeApplicationForm.contains('steerAxleManuBox')) {
        }
        this.cdr.detectChanges();
      }));
    }));
  }
  formfieldAutoupdater(res) {
    this.populateForm(res?.formData);
    this.populateCheckbox(res?.formData);
    // Call updateFormValues for each case
    this.updateFormValues(res?.formData?.levelOfExp, this.levelofExperience, this.levelOfExp);
    this.updateFormValues(res?.formData?.enduranceBreakSys, this.EnduranceBrakeSystem, this.endBrkSys);
    this.updateFormValues(res?.formData?.projectTarget, this.projectTargetContent, this.projectTgt);
    this.updateFormValues(res?.formData?.oemPTReq, this.oemPTReqContent, this.oemptreq);
    this.updateFormValues(res?.formData?.vehicleOEC, this.vehicleOECContent, this.vehicleoec);
  }
  loopDropDownListArray(dropdownlist: any) {
    dropdownlist.map((item) => {
      if (item.code == 'OEM') {
        this.oEM = item?.chassisList;
      }
      if (item.code == 'CAD') {
        this.three3DCAD = item?.chassisList;
      }
      if (item.code == 'VM') {
        this.vehicleModel = item?.chassisList;
      }
      if (item.code == 'VT') {
        this.vehicleType = item?.chassisList;
      }
      if (item.code == 'FT') {
        this.fieldTestPlanned = item?.chassisList;
      }
      if (item.code == 'VOC') {
        this.vocation = item?.chassisList;
      }
      if (item?.code == 'PS') {
        this.pneumatic = item?.chassisList;
      }
      if (item?.code == 'BT') {
        this.brakeType = item?.chassisList;
      }
      if (item?.code == 'AM') {
        this.axleManufacturer = item?.chassisList;
      }
      if (item?.code == 'BAIP') {
        this.partPerforming = item?.chassisList;
      }
      if (item?.code == 'AS') {
        this.axleDesign = item?.chassisList;
      }
      if (item?.code == 'TOC') {
        this.tOCAxleFlange = item?.chassisList;
      }
      if (item?.code == 'AXT') {
        this.axleType = item?.chassisList;
      }
      if (item?.code == 'AXP') {
        this.intendedOrDesigned = item?.chassisList;
      }
      this.vehicleDetails(item);
    });
    this.loadAllCheckboxes();
  }

  vehicleDetails(item) {
    if (item?.code == 'AXTT') {
      this.tireType = item?.chassisList;
    }
    if (item?.code == 'AAXT') {
      this.auxiliaryAxleType = item?.chassisList;
    }
    if (item?.code == 'EXP') {
      this.levelofExperience = item?.chassisList;
    }
    if (item?.code == 'PT') {
      this.projectTargetContent = item?.chassisList;
    }
    if (item?.code == 'EBS') {
      this.EnduranceBrakeSystem = item?.chassisList;
    }
    if (item?.code == 'OEMPT') {
      this.oemPTReqContent = item?.chassisList;
    }
    if (item?.code == 'OEC') {
      this.vehicleOECContent = item?.chassisList;
    }
    if (item?.code == 'AAA') {
      this.addAuxleAttrContent = item?.chassisList;
    }
  }

  addDynamicfields() {
    this.addDynamicfields1();
    this.addDynamicfields2();
    if (this.bAF.targetDateAvailable.value == 'true') {
      (this.brakeApplicationForm as FormGroup).addControl('sampleADate', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('sampleADate');
    }
    if (this.bAF.vehicleOperationalOutside.value == 'true') {
      (this.brakeApplicationForm as FormGroup).addControl('vehicleOperationalOutsideText', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('vehicleOperationalOutsideText');
    }
    if (this.bAF.brakeEquippeds.value == 'true') {
      (this.brakeApplicationForm as FormGroup).addControl('brakeEquippedsBox', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('brakeEquippedsBox');
    }
    if (this.bAF.endUserPTReq.value == 'false') {
      (this.brakeApplicationForm as FormGroup).addControl('endUserPTBox', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('endUserPTBox');
    }
    //checkbox
    if (this.oemptreq.value[2]) {
      (this.brakeApplicationForm as FormGroup).addControl('oemPTReqBox', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('oemPTReqBox');
    }
  }

  addDynamicfields1() {
    if (this.bAF.oem?.value?.toLowerCase() == 'other') {
      (this.brakeApplicationForm as FormGroup).addControl('oemBox', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('oemBox');
    }
    if (this.bAF.vocation?.value?.toLowerCase() == 'other') {
      (this.brakeApplicationForm as FormGroup).addControl('vocationBox', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('vocationBox');
    }
    if (this.bAF.vehicleModel?.value?.toLowerCase() == 'other') {
      (this.brakeApplicationForm as FormGroup).addControl('vehicleModelMsg', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('vehicleModelMsg');
    }
    if (this.bAF.vehicleType?.value?.toLowerCase() == 'other') {
      (this.brakeApplicationForm as FormGroup).addControl('vehicleTypeBox', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('vehicleTypeBox');
    }

    if (this.bAF.driveAxleManu?.value?.toLowerCase() == 'other') {
      this.bAF.driveAxleManuBox.enable();
    } else {
      this.bAF.driveAxleManuBox.disable();
    }
  }

  addDynamicfields2() {
    if (this.bAF.driveAxleTOC.value == 'NON_BENDIX') {
      this.bAF.driveAxleTOCBox.enable();
    } else {
      this.bAF.driveAxleTOCBox.disable();
    }

    if (this.bAF.steerAxleManu?.value?.toLowerCase() == 'other') {
      this.bAF.steerAxleManuBox.enable();
    } else {
      this.bAF.steerAxleManuBox.disable();
    }
    if (this.bAF.steerAxleTOC?.value == 'NON_BENDIX') {
      this.bAF.steerAxleTOCBox.enable();
    } else {
      this.bAF.steerAxleTOCBox.disable();
    }
    if (this.bAF.ftPlanned?.value == 'NO_FIELD_TESTS') {
      this.bAF.ftVehicleCount.reset();
      this.bAF.ftVehicleCount.disable();
    } else {
      this.bAF.ftVehicleCount.enable();
    }
    //radiobuttons  ftPlanned
    if (this.bAF.samplesRequired.value == 'true') {
      (this.brakeApplicationForm as FormGroup).addControl('sampleANum', this.fb.control('', [Validators.required]));
    } else {
      (this.brakeApplicationForm as FormGroup).removeControl('sampleANum');
    }
  }


  //adding Form Array
  addDynamic() {
    this.updateAuxAxleAttributes(this.addAuxleAttrContent);
  }
  //removing form Array
  removeDynamic(i: number) {
    this.auxAxleList.removeAt(i);
  }
  //checkboxes section
  loadAllCheckboxes() {
    this.updatelevelOfExp(this.levelofExperience);
    this.updateprojectTgt(this.projectTargetContent);
    this.updateenduranceBreakSys(this.EnduranceBrakeSystem);
    this.updateoemPTReq(this.oemPTReqContent);
    this.updatevehicleOEC(this.vehicleOECContent);

  }
  updatelevelOfExp(chassisList: any) {
    const checkboxes = chassisList.map(() => {
      return this.fb.control(false);
    });

    const auxAxleAttributesFormArray = this.fb.array(checkboxes);
    this.brakeApplicationForm.setControl('levelOfExp', auxAxleAttributesFormArray);
  }
  get levelOfExp() {
    return this.brakeApplicationForm.get('levelOfExp') as FormArray;
  }
  updateprojectTgt(chassisList: any) {
    const checkboxes = chassisList.map(() => {
      return this.fb.control(false);
    });

    const auxAxleAttributesFormArray = this.fb.array(checkboxes);
    this.brakeApplicationForm.setControl('projectTarget', auxAxleAttributesFormArray);
  }
  get projectTgt() {
    return this.brakeApplicationForm.get('projectTarget') as FormArray;
  }
  updateenduranceBreakSys(chassisList: any) {
    const checkboxes = chassisList.map(() => {
      return this.fb.control(false);
    });

    const auxAxleAttributesFormArray = this.fb.array(checkboxes);
    this.brakeApplicationForm.setControl('enduranceBreakSys', auxAxleAttributesFormArray);
  }
  get endBrkSys() {
    return this.brakeApplicationForm.get('enduranceBreakSys') as FormArray;
  }
  updateoemPTReq(chassisList: any) {
    const checkboxes = chassisList.map(() => {
      return this.fb.control(false);
    });

    const auxAxleAttributesFormArray = this.fb.array(checkboxes);
    this.brakeApplicationForm.setControl('oemPTReq', auxAxleAttributesFormArray);
  }
  get oemptreq() {
    return this.brakeApplicationForm.get('oemPTReq') as FormArray;
  }
  updatevehicleOEC(chassisList: any) {
    const checkboxes = chassisList.map(() => {
      return this.fb.control(false);
    });

    const auxAxleAttributesFormArray = this.fb.array(checkboxes);
    this.brakeApplicationForm.setControl('vehicleOEC', auxAxleAttributesFormArray);
  }
  get vehicleoec() {
    return this.brakeApplicationForm.get('vehicleOEC') as FormArray;
  }
  updateAuxAxleAttributes(chassisList: any) {
    const auxAxleListArray = this.brakeApplicationForm.get('auxAxleList') as FormArray;
    const auxAxleFormGroup = this.dynamicFormArray();

    auxAxleFormGroup.setControl('auxAxleAttributes', this.fb.array(
      chassisList.map(() => this.fb.control(false))
    ));

    auxAxleListArray.push(auxAxleFormGroup);
  }
  get FormArrayauxAxleList() {
    return this.brakeApplicationForm.get('auxAxleList') as FormArray;
  }

  getFormArrayAuxAxleAttributes(index: number) {
    const auxAxleFormGroup = this.auxAxleList.at(index) as FormGroup;
    return auxAxleFormGroup.get('auxAxleAttributes') as FormArray;
  }

  downLoadAdminAddedAttachments() {
    const byteArray = this.BrakeFormGetApiData.adminFileAttachmentZip.fileCode;
    const name = this.eAdminF.applicationNum.value;
    try {
      const decodedByteArray = atob(byteArray);
      const zipArray = new Uint8Array(decodedByteArray.length);
      for (let i = 0; i < decodedByteArray.length; i++) {
        zipArray[i] = decodedByteArray.charCodeAt(i);
      }
      if (isPlatformBrowser(this.platformId)) {
        const zipBlob = new Blob([zipArray], { type: 'application/zip' });
        const zipUrl = window.URL.createObjectURL(zipBlob);

        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = name + '.zip';
        link.click();

        this.cleanupDownloadUrl(zipUrl);
      }
    } catch (error) {
      console.error('Error downloading ZIP file:', error);
    }

  }
  private cleanupDownloadUrl(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.timeout = setTimeout(() => window.URL.revokeObjectURL(url), 0);
    }
  }
  openDialog() {
    this.matDialog.open(BrakeAppAdminDialogPopupComponent, { data: this.BrakeFormGetApiData?.fileAttachmentList });
  }

  populateForm(data: any) {
    const ArrayData = data?.auxAxleList;
    const auxAxleListFormControl = this.brakeApplicationForm.get('auxAxleList') as FormArray;
    auxAxleListFormControl.controls.map((fg: FormGroup, index) => {
      for (const controlName in fg.controls) {
        if (fg.controls.hasOwnProperty(controlName)) {
          const control = this.getAxleListControl(index, controlName);
          if (control instanceof FormControl) {
            const value = ArrayData?.[index][controlName];
            this.checkUndefined(control, value);
          } else if (control instanceof FormArray) {
          }
        }
      }

    })
    for (const controlName in this.brakeApplicationForm.controls) {
      this.checkFormControls(controlName, data);
    }

  }

  checkUndefined(control, value) {
    if (control && value !== undefined) {
      control.setValue(value !== undefined ? value : null);
    }
  }

  checkFormControls(controlName, data) {
    if (this.brakeApplicationForm.controls.hasOwnProperty(controlName)) {
      const control = this.brakeApplicationForm.get(controlName);
      if (control instanceof FormControl) {
        // Handle FormControls
        const value = data?.[controlName];
        this.checkFormValue(control, controlName, value);
      } else if (control instanceof FormArray) {
        // Handle FormArrays
      } else {
        console.warn(`Unsupported control type for ${controlName}`);
      }
    }
  }

  checkFormValue(control, controlName, value) {
    if ((controlName == 'samplesRequired') ||
      (controlName == 'targetDateAvailable') ||
      (controlName == 'vehicleOperationalOutside') ||
      (controlName == 'endUserPTReq') ||
      (controlName == 'steerAxleDriven') ||
      (controlName == 'brakeEquippeds')) {
      control.setValue(value ? 'true' : 'false');
    } else if ((controlName == 'sampleADate') ||
      (controlName == 'productionStartDate') || (controlName == 'date')) {

      if (value.length > 0 && value != 'undefined' && value != null) {
        const DataDate = new Date(value);
        control.setValue(DataDate);
      }
    }
    else if (control && value !== undefined) {
      console.warn(controlName == 'driveAxleTOCBox')
      if (controlName == 'driveAxleTOCBox') {
        console.warn(value, controlName);
      }

      control.setValue(value !== undefined ? value : null);

    }
  }

  populateCheckbox(data: any) {
    const ApiData = data?.auxAxleList;

    ApiData.forEach((content, index) => {
      if (content?.auxAxleAttributes && content?.auxAxleAttributes.length > 0) {
        const numOptions = this.addAuxleAttrContent.length;

        // Create updatedValues with default false
        const updatedValues = new Array(numOptions).fill(false);

        // Update updatedValues based on the codes present in content.auxAxleAttributes
        content.auxAxleAttributes.forEach(code => {
          const matchingOptionIndex = this.addAuxleAttrContent.findIndex(option => option.code === code);
          if (matchingOptionIndex !== -1) {
            updatedValues[matchingOptionIndex] = true;
          }
        });

        // Retrieve current values and ensure length match
        const currentValues = this.getFormArrayAuxAxleAttributes(index).value || new Array(numOptions).fill(false);

        // Ensure the length of updatedValues matches currentValues
        if (updatedValues.length === currentValues.length) {
          this.getFormArrayAuxAxleAttributes(index).setValue(updatedValues);
        } else {
          console.error("Length mismatch between updatedValues and currentValues");
          // Handle mismatch: Adjust updatedValues to match currentValues length if necessary
          const adjustedValues = updatedValues.slice(0, currentValues.length).concat(
            new Array(Math.max(currentValues.length - updatedValues.length, 0)).fill(false)
          );
          this.getFormArrayAuxAxleAttributes(index).setValue(adjustedValues);
        }
      } else {
        // Handle case where content.auxAxleAttributes is empty or undefined
        const numOptions = this.addAuxleAttrContent.length;
        const defaultValues = new Array(numOptions).fill(false);
        this.getFormArrayAuxAxleAttributes(index).setValue(defaultValues);
      }
    });

  }
  updateFormValues(dataArray, optionsArray, formControl) {
    const numOptions = optionsArray.length;

    // Create updatedValues with default false
    const updatedValues = new Array(numOptions).fill(false);

    if (dataArray && dataArray.length > 0) {
      // Update updatedValues based on the codes present in dataArray
      dataArray.forEach(code => {
        const matchingOptionIndex = optionsArray.findIndex(option => option.code === code);
        if (matchingOptionIndex !== -1) {
          updatedValues[matchingOptionIndex] = true;
        }
      });
    }

    // Retrieve current values and ensure length match
    const currentValues = formControl.value || new Array(numOptions).fill(false);

    // Ensure the length of updatedValues matches currentValues
    if (updatedValues.length === currentValues.length) {
      formControl.setValue(updatedValues);
    } else {
      console.error("Length mismatch between updatedValues and currentValues");
      // Handle mismatch: Adjust updatedValues to match currentValues length if necessary
      const adjustedValues = updatedValues.slice(0, currentValues.length).concat(
        new Array(Math.max(currentValues.length - updatedValues.length, 0)).fill(false)
      );
      formControl.setValue(adjustedValues);
    }
  }

  booleanToString(value: boolean): string {
    return value ? 'true' : 'false';
  }
  updateRadioButtonFormControls(response) {
    this.brakeApplicationForm.patchValue({
      samplesRequired: this.booleanToString(response.samplesRequired),
      targetDateAvailable: this.booleanToString(response.targetDateAvailable),
      vehicleOperationalOutside: this.booleanToString(response.vehicleOperationalOutside),
      endUserPTReq: this.booleanToString(response.endUserPTReq),
      steerAxleDriven: this.booleanToString(response.steerAxleDriven),
      brakeEquippeds: this.booleanToString(response.brakeEquippeds),
    });
  }


  populateEngineeringForm(data: any) {

    const appDate = new Date(data?.applicationDate);

    this.eAdminF.adminName.setValue(data?.adminName);
    this.eAdminF.applicationNum.setValue(data?.applicationNum);
    this.eAdminF.applicationDate.setValue(data?.applicationDate);
    this.eAdminF.partNumber.setValue(data?.partNumber);
    this.eAdminF.applicationFront.setValue(data?.applicationFront);
    this.eAdminF.applicationForward.setValue(data?.applicationForward);
    this.eAdminF.additionComments.setValue(data?.additionComments);
    this.eAdminF.applicationMid.setValue(data?.applicationMid);
    this.eAdminF.applicationRear.setValue(data?.applicationRear);
    this.eAdminF.applicationPusher.setValue(data?.applicationPusher);
    this.eAdminF.applicationTag.setValue(data?.applicationTag);
    this.eAdminF.applicationAxle.setValue(data?.applicationAxle);
    this.eAdminF.applicationMail.setValue(data?.applicationMail);
    this.eAdminF.approavalStatus.setValue(data?.approavalStatus);
    this.eAdminF.approvalType.setValue(data?.approvalType);
    this.adminComments = data?.additionComments;
  }
  onSubmit() {
    this.callPostApi(false, true);
  }
  onSave() {
    this.callPostApi(true, false);
  }
  forReview() {
    const canProceed = this.checkBoxChecker();
    this.checkFormClicked = true;
    if (canProceed && this.brakeApplicationForm.valid) {
      this.isFormFilledSuccessfully = true;
      this.isFormContainsError = false;
      this.savedSuccessFully = false;
      this.scroller.scrollToPosition([0, 150]);
      this.cdr.detectChanges();
    } else {
      this.savedSuccessFully = false;
      this.isFormContainsError = true;
      this.brakeApplicationForm.markAllAsTouched();
      this.scroller.scrollToPosition([0, 150]);
      this.cdr.detectChanges();
    }

  }
  getSelectedCheckBoxesCodes() {
    let ApiFormatPayload = this.brakeApplicationForm.value;

    // Function to extract selected codes based on boolean values and options array
    const extractSelectedCodes = (formControl, options) => {
      return formControl.value.reduce((selectedCodes, isSelected, index) => {
        if (isSelected) {
          selectedCodes.push(options[index].code);
        }
        return selectedCodes;
      }, []);
    };

    // Extract selected codes for each form control
    const levelOfExpCheckboxApi = extractSelectedCodes(this.bAF.levelOfExp, this.levelofExperience);
    const projectTargetCheckBoxApi = extractSelectedCodes(this.bAF.projectTarget, this.projectTargetContent);
    const EnduranceBrakeSystemCheckboxAPI = extractSelectedCodes(this.bAF.enduranceBreakSys, this.EnduranceBrakeSystem);
    const oemPTReqContentCheckboxApi = extractSelectedCodes(this.bAF.oemPTReq, this.oemPTReqContent);
    const vehicleOECContentChecKBoxApi = extractSelectedCodes(this.bAF.vehicleOEC, this.vehicleOECContent);

    // Update ApiFormatPayload with extracted codes
    ApiFormatPayload = {
      ...ApiFormatPayload,
      levelOfExp: levelOfExpCheckboxApi,
      projectTarget: projectTargetCheckBoxApi,
      enduranceBreakSys: EnduranceBrakeSystemCheckboxAPI,
      oemPTReq: oemPTReqContentCheckboxApi,
      vehicleOEC: vehicleOECContentChecKBoxApi,
    };



    ApiFormatPayload.auxAxleList.forEach((data: any, index) => {
      const addAuxleAttrContentCheckBoxApi = data.auxAxleAttributes
        .map((code, _index) => code ? this.addAuxleAttrContent[_index].code : null)
        .filter(code => code !== null);

      ApiFormatPayload.auxAxleList[index]['auxAxleAttributes'] = addAuxleAttrContentCheckBoxApi;
    });

    return ApiFormatPayload;

  }
  checkBoxChecker(): boolean {
    const levelofExper = this.bAF.levelOfExp.value;
    const projecttarget = this.bAF.projectTarget.value;
    const endurancebrakesys = this.bAF.enduranceBreakSys.value;
    const AllFalselevelofExper = levelofExper.every(value => value === false);
    const AllFalseprojecttarget = projecttarget.every(value => value === false);
    const AllFalseendurancebrakesys = endurancebrakesys.every(value => value === false);
    if (AllFalselevelofExper) {
      this.levelofExpError = true;
    } else {
      this.levelofExpError = false;
    }
    if (AllFalseprojecttarget) {
      this.projecttargetError = true;
    } else {
      this.projecttargetError = false;
    }
    if (AllFalseendurancebrakesys) {
      this.endurancebrakeSyserror = true;
    } else {
      this.endurancebrakeSyserror = false;
    }
    return !AllFalselevelofExper && !AllFalseprojecttarget && !AllFalseendurancebrakesys;
  }
  callPostApi(saveForlater: boolean, finalSubmit: boolean) {
    const canuploadFile = this.fileService.isAtLeastOneFilePresent();
    const files = new FormData();
    if (canuploadFile) {
      const file = this.fileService.getAllFiles();
      file.forEach((file) => {
        files.append('file', file);
      })
    }

    const payLoad = this.getSelectedCheckBoxesCodes();
    let code;

    this.sub.add(this.service.brakeAppFormEditablePostApi(payLoad, this.brakeAppCode, saveForlater, finalSubmit).subscribe((res: any) => {
      if (res.message.status == 'SUCCESS') {
        if (saveForlater) {
          this.savedSuccessFully = true;
          this.submittedSuccessFully = false;
        }
        if (finalSubmit) {
          this.submittedSuccessFully = true;
          this.savedSuccessFully = false;
          this.brakeApplicationForm.disable();
        }
        this.scroller.scrollToPosition([0, 150]);
        code = res?.formData?.applicationNum;
        this.bAF.applicationNum.setValue(code);
        this.cdr.detectChanges();
      }
      if (canuploadFile) {
        this.sub.add(this.service.sendFileAfterpost(files, code).subscribe((response: any) => {
          if (response) {
          }
        }));
      }

    }));
  }
  ngOnDestroy() {
    this.fileService.clearAllFiles();
    this.sub.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
